import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import Autocomplete from 'views/components/input/Autocomplete';
import TextField from 'views/components/input/TextField';

import {ExpandMore} from 'views/icons';

const AutocompleteInput = (props) => {
  const {questionData, value, onChange, options} = props;

  const optionList = options || [];
  const selectedOption = optionList.find((option) => option.value === value) || null;

  return (
    <Box>
      <Autocomplete
        options={optionList}
        value={selectedOption}
        onChange={(option) => onChange(option?.value ?? '')}
        getOptionLabel={(option) => option?.label ?? ''}
        isOptionEqualToValue={(option, selected) => option.value === selected.value}
        popupIcon={<ExpandMore />}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={questionData?.placeholder || ''}
            onChange={params.inputProps?.onChange || (() => {})}
            onChangeEvent
            InputProps={{
              ...params.InputProps,
              sx: {
                borderRadius: '12px',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '150%',
              },
            }}
          />
        )}
        ListboxProps={{
          style: {maxHeight: 240, overflow: 'auto'},
        }}
      />
    </Box>
  );
};

AutocompleteInput.propTypes = {
  questionData: PropTypes.shape({
    helpText: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
  }).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
};

export default AutocompleteInput;
